// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"695":"7a66ea11","740":"3c48d2e8"}[chunkId] + ".chunk.js";
};